import { useFormik } from "formik";
import Link from "next/link";
import { Image } from "react-bootstrap";
import * as Yup from "yup";
import { useAuth } from "@/hooks/auth";
import { useRouter } from "next/router";
import { useState } from "react";
import { useToasts } from "@/hooks/toasts";


export default function ForgotPassword()
{
    const router = useRouter();
    const { forgotPassword } = useAuth();
    const [status, setStatus] = useState(null);
    const { addToast } = useToasts();

    const forgotPasswordValidationSchema = Yup.object().shape({
        email: Yup.string().email("Invalid email").required("Email is required"),
    });
    const forgotPwdForm = useFormik({
        initialValues: {
            email: "",
        },

        validationSchema: forgotPasswordValidationSchema,
        onSubmit: async (values, { setSubmitting }) =>
        {
            try
            {
                await forgotPassword({
                    email: values.email,
                    setStatus,
                });
                addToast("success", "Password reset link sent to your email.");
            } catch (error)
            {
                console.error("Forgot password error:", error?.response || "error while sending mail");
                addToast("danger", error?.response?.data?.message || "Something went wrong. Please try again.");
            } finally
            {
                setSubmitting(false);
            }
        },
    });

    return (
        <section className="d-flex flex-column justify-content-center">
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-7 col-lg-5 col-xl-4 text-center">
                        <Link className="" href="/"><Image src="/images/instant-polls-logo.jpg" alt="Instant Polls Logo" className="d-block mx-auto forgotPwdLogo"/></Link>
                        <h1 className="h2 fw-bold my-3">Forgot your password</h1>
                        <form noValidate onSubmit={forgotPwdForm.handleSubmit}>
                            <div className="form-floating mb-3">
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    className="form-control"
                                    value={forgotPwdForm.values.email}
                                    onChange={forgotPwdForm.handleChange}
                                    onBlur={forgotPwdForm.handleBlur}
                                    placeholder="name@example.com"
                                />
                                <label htmlFor="email">Email address</label>
                                {forgotPwdForm.touched.email && forgotPwdForm.errors.email && (
                                    <div className="text-start text-danger text-sm font14">
                                        {forgotPwdForm.errors.email}
                                    </div>
                                )}
                            </div>
                            {status && <div className="alert alert-info">{status}</div>}
                            <button
                                className="btn btn-primary w-100 py-2"
                                type="submit"
                            >
                                Forgot Password
                            </button>
                            
                        </form>
                        <div className="mt-3 text-center">
                            <p className="mb-4">
                                <Link href="/register">Create an account</Link> |{" "}
                                <Link href="/login">Sign In</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
ForgotPassword.layout = 'blank';